"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Welcome_1 = __importDefault(require("./Welcome"));
exports.default = Welcome_1.default;
